<template>
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1455 9.78511L17.5744 3.46977C17.6776 3.01379 17.3326 2.57958 16.867 2.57958H4.99431L4.71725 1.21905C4.64821 0.879934 4.35113 0.636398 4.00651 0.636398H0.907339C0.506677 0.636398 0.181885 0.96264 0.181885 1.36509V1.85089C0.181885 2.25334 0.506677 2.57958 0.907339 2.57958H3.01971L5.14312 13.007C4.63512 13.3005 4.29279 13.8507 4.29279 14.4816C4.29279 15.4206 5.05065 16.1819 5.98552 16.1819C6.92039 16.1819 7.67825 15.4206 7.67825 14.4816C7.67825 14.0057 7.48337 13.5757 7.1697 13.2671H13.5068C13.1931 13.5757 12.9982 14.0057 12.9982 14.4816C12.9982 15.4206 13.7561 16.1819 14.691 16.1819C15.6258 16.1819 16.3837 15.4206 16.3837 14.4816C16.3837 13.8084 15.9941 13.2266 15.4292 12.9512L15.5959 12.2141C15.6991 11.7581 15.354 11.3239 14.8885 11.3239H6.77497L6.57713 10.3523H15.4381C15.7768 10.3523 16.0705 10.1169 16.1455 9.78511Z"
      fill="#110F13"
    />
  </svg>
</template>
